





























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ReferralIcon from "@/components/ReferralIcon.vue";
import { ReferralTriageDetailsModel } from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "referral-icon": ReferralIcon,
    "information-card": InformationCard,
  },
})
export default class ReferralDetailsView extends Vue {
  @Prop()
  advancedMode!: boolean;

  @Prop({ default: null })
  referral!: ReferralTriageDetailsModel;
}
